import Enum from '../../utils/enum'

const GroupType = new Enum([
  'ESCALATION',
  'GROUP',
  'FORUM',
  'PATIENT_CARE',
  'PATIENT_MESSAGING',
  'ROLE_ASSIGNMENT',
  'ROLE_P2P',
])

export default GroupType
